import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ActivityLog\StoreCustomActivityLogController::__invoke
* @see app/Http/Controllers/ActivityLog/StoreCustomActivityLogController.php
* @route '/api/activity'
*/
const StoreCustomActivityLogController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreCustomActivityLogController.url(options),
    method: 'post',
})

StoreCustomActivityLogController.definition = {
    methods: ["post"],
    url: '/api/activity',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ActivityLog\StoreCustomActivityLogController::__invoke
* @see app/Http/Controllers/ActivityLog/StoreCustomActivityLogController.php
* @route '/api/activity'
*/
StoreCustomActivityLogController.url = (options?: RouteQueryOptions) => {
    return StoreCustomActivityLogController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ActivityLog\StoreCustomActivityLogController::__invoke
* @see app/Http/Controllers/ActivityLog/StoreCustomActivityLogController.php
* @route '/api/activity'
*/
StoreCustomActivityLogController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreCustomActivityLogController.url(options),
    method: 'post',
})

export default StoreCustomActivityLogController